import { render, staticRenderFns } from "./CreatePost.vue?vue&type=template&id=6a66f7c0&scoped=true"
import script from "./CreatePost.vue?vue&type=script&lang=js"
export * from "./CreatePost.vue?vue&type=script&lang=js"
import style0 from "./CreatePost.vue?vue&type=style&index=0&id=6a66f7c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a66f7c0",
  null
  
)

export default component.exports